export const CLIENT_KEY = 'hello';
export const TWOFA_KEY = 'Thi1sIs3';
